import { render, staticRenderFns } from "./CPageContactFinishStandard.vue?vue&type=template&id=58b8b789&"
import script from "./CPageContactFinishStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageContactFinishStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports